<div
  class="font-lato min-h-50 w-full rounded-[20px] bg-white max-md:rounded-none"
>
  @if (loading) {
    <div class="loading-spinner mt-10 flex justify-center">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  } @else {
    <div class="items-center px-4 pb-4 max-md:overflow-x-scroll">
      @if (
        filterService.length || filterStatus.length || filterAddress.length
      ) {
        <div class="flex flex-wrap gap-2 px-2.5 pb-3">
          @for (filter of filterService; track filter.attrs.label) {
            <span
              class="font-lato inline-flex items-center gap-1 rounded-full border border-blue-200 bg-blue-50 px-3 py-1 text-sm text-blue-800"
            >
              {{ filter.attrs.label }}
              <button
                type="button"
                class="ml-0.5 rounded-full p-0.5 hover:bg-blue-100 focus:outline-none"
                (click)="removeThis('service', filter)"
                [attr.aria-label]="
                  'Remove service filter ' + filter.attrs.label
                "
              >
                <mat-icon
                  class="!flex !h-3.5 !w-3.5 !items-center !justify-center !text-sm"
                  >close</mat-icon
                >
              </button>
            </span>
          }
          @for (filter of filterStatus; track filter.attrs.label) {
            <span
              class="font-lato inline-flex items-center gap-1 rounded-full border border-gray-200 bg-gray-100 px-3 py-1 text-sm text-gray-700"
            >
              {{ filter.attrs.label }}
              <button
                type="button"
                class="ml-0.5 rounded-full p-0.5 hover:bg-gray-200 focus:outline-none"
                (click)="removeThis('status', filter)"
                [attr.aria-label]="'Remove status filter ' + filter.attrs.label"
              >
                <mat-icon
                  class="!flex !h-3.5 !w-3.5 !items-center !justify-center !text-sm"
                  >close</mat-icon
                >
              </button>
            </span>
          }
          @for (filter of filterAddress; track filter.attrs.label) {
            <span
              class="font-lato inline-flex items-center gap-1 rounded-full border border-violet-200 bg-violet-50 px-3 py-1 text-sm text-violet-800"
            >
              {{ filter.attrs.label }}
              <button
                type="button"
                class="ml-0.5 rounded-full p-0.5 hover:bg-violet-100 focus:outline-none"
                (click)="removeThis('address', filter)"
                [attr.aria-label]="
                  'Remove address filter ' + filter.attrs.label
                "
              >
                <mat-icon
                  class="!flex !h-3.5 !w-3.5 !items-center !justify-center !text-sm"
                  >close</mat-icon
                >
              </button>
            </span>
          }
        </div>
      }

      <table
        mat-table
        multiTemplateDataRows
        matSort
        [dataSource]="dataSource"
        class="mat-elevation-z0 font-lato [&_td]:font-lato w-full rounded-[10px] [&_mat-icon]:cursor-pointer [&_td]:py-3 [&_td]:text-sm [&_th]:text-sm [&_th]:font-bold! [&_th]:tracking-wide [&_th]:text-black! [&_th]:uppercase"
      >
        <ng-container matColumnDef="id">
          <th mat-header-cell mat-sort-header *matHeaderCellDef># ID</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="deal">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Deal</th>
          <td mat-cell *matCellDef="let element">{{ element.deal }}</td>
        </ng-container>

        <ng-container matColumnDef="oli">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>OLI</th>
          <td mat-cell *matCellDef="let element">{{ element.oli }}</td>
        </ng-container>

        <ng-container matColumnDef="line_type">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Order Type</th>
          <td mat-cell *matCellDef="let element">{{ element.line_type }}</td>
        </ng-container>

        <ng-container matColumnDef="nit">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>NIT</th>
          <td mat-cell *matCellDef="let element">{{ element.nit }}</td>
        </ng-container>

        <ng-container matColumnDef="site">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Site</th>
          <td mat-cell *matCellDef="let element">{{ element.site }}</td>
        </ng-container>

        <ng-container matColumnDef="address">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Address</th>
          <td mat-cell *matCellDef="let element">{{ element.address }}</td>
        </ng-container>

        <ng-container matColumnDef="city">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>City</th>
          <td mat-cell *matCellDef="let element">{{ element.city }}</td>
        </ng-container>

        <ng-container matColumnDef="state">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>State</th>
          <td mat-cell *matCellDef="let element">{{ element.state }}</td>
        </ng-container>

        <ng-container matColumnDef="service">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Service</th>
          <td mat-cell *matCellDef="let element">{{ element.service }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">{{ element.status }}</td>
        </ng-container>

        <ng-container matColumnDef="foc_date">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>FOC Date</th>
          <td mat-cell *matCellDef="let element">{{ element.foc_date }}</td>
        </ng-container>

        <ng-container matColumnDef="expands">
          <th mat-header-cell *matHeaderCellDef>
            <button
              type="button"
              class="inline-flex cursor-pointer items-center justify-center rounded-full border-none bg-transparent p-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-700 focus-visible:ring-offset-1"
              [attr.aria-expanded]="allExpanded"
              [attr.aria-label]="
                allExpanded ? 'Collapse all orders' : 'Expand all orders'
              "
              (click)="toggleExpandAll()"
            >
              <mat-icon aria-hidden="true">{{
                allExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
              }}</mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef="let element">
            <button
              type="button"
              class="inline-flex cursor-pointer items-center justify-center rounded-full border-none bg-transparent p-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-700 focus-visible:ring-offset-1"
              [attr.aria-expanded]="!!element.expanded"
              [attr.aria-label]="
                (element.expanded ? 'Collapse order ' : 'Expand order ') +
                element.id +
                ' details'
              "
              (click)="
                $event.stopPropagation(); element.expanded = !element.expanded
              "
            >
              <mat-icon aria-hidden="true">{{
                element.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
              }}</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="orderColumns.length"
            [ngClass]="{ 'border-t border-black/12': element.expanded }"
          >
            <div
              class="grid w-full overflow-hidden transition-[grid-template-rows] duration-225 ease-in-out"
              [ngClass]="
                element.expanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
              "
            >
              <app-extended-row
                class="min-h-0 w-full overflow-hidden"
                [order]="element.full_order"
                (openOrder)="openOrder($event)"
              ></app-extended-row>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="orderColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: orderColumns"
          class="cursor-pointer border-b border-gray-100 hover:bg-blue-50/40 [&_td]:border-b-0"
          (click)="row.expanded = !row.expanded"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="h-0! overflow-hidden [&_td]:border-0! [&_td]:p-0!"
        ></tr>
      </table>

      <mat-paginator
        #paginatorElement
        [pageSizeOptions]="pageSizeOptions"
        (page)="setSelectValueToAll()"
        (click)="setOptionLabelToAll()"
        showFirstLastButtons
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
    </div>
  }
</div>
